/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

export enum AviNotificationType {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info',
}

/**
 * Type for a user-defined action to click on within a notification pop-up.
 */
export interface IAviNotificationAction {
    label: string;
    onClick(): any;
}
